import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getBookProofsByOwnerOptions } from '@/module/Author/Book/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface BookOwnerProofListProps {
  bookId: Id;
  userId: Id;
}

export function BookOwnerProofList({ bookId, userId }: BookOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getBookProofsByOwnerOptions(bookId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="book"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
